import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface SpinnerProps extends React.HTMLAttributes<SVGElement> {
  size?: "sm" | "md" | "lg";
}

const sizeVariants = {
  sm: "h-5 w-5",
  md: "h-7 w-7",
  lg: "h-10 w-10",
};

export const Spinner = ({ size = "sm", className, ...props }: SpinnerProps) => {
  return (
    <Loader2
      className={cn(
        "animate-spin",
        sizeVariants[size],
        className
      )}
      {...props}
    />
  );
};
